<template>
  <div>
    <SchemaTablePage
      ref="tablePageRef"
      layout-mode="tab"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
    >
      <template #colStatus="{ row }">
        <el-tag :type="row.status === 1 ? 'success' : 'info'" size="mini">
          {{ row.status === 1 ? '启用' : '禁用' }}
        </el-tag>
      </template>
      <template #colPayoutLimit="{ row }">
        <span
          >{{ centsToYuan(row.payout_min_amount) }} - {{ centsToYuan(row.payout_max_amount) }} {{ row.currency }}</span
        >
      </template>
      <template #colPayoutFee="{ row }">
        {{ row.payout_fee_rate + '%' || '-' }}
      </template>
      <template #colActions="{ row }">
        <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
      </template>
    </SchemaTablePage>

    <PaymentChannelDialog
      :visible.sync="dialogVisible"
      :mode="dialogMode"
      channel-type="payout"
      :edit-id="editId"
      :edit-row="editRow"
      @success="handleDialogSuccess"
    />
  </div>
</template>

<script>
import { listPayoutChannels } from '@/api/finance/paymentChannel'
import { centsToYuan, yuanToCents } from '@/utils/amount'
import PaymentChannelDialog from './PaymentChannelDialog.vue'
import SchemaTablePage from '@/components/SchemaTablePage'

export default {
  name: 'ManagePayoutChannelTab',
  components: { PaymentChannelDialog, SchemaTablePage },
  data() {
    return {
      centsToYuan,
      yuanToCents,
      defaultQuery: {
        channel_name: '',
        status: '',
      },
      searchSchema: [
        {
          prop: 'channel_name',
          label: '通道名称',
          component: 'input',
          componentProps: { clearable: true },
        },
        {
          prop: 'status',
          label: '通道状态',
          component: 'select',
          componentProps: { clearable: true },
          options: [
            { label: '全部', value: '' },
            { label: '启用', value: 1 },
            { label: '禁用', value: 2 },
          ],
        },
        { component: 'actions' },
      ],
      tableColumns: [
        // { type: 'index', label: '序号', width: 60, align: 'center', resizable: false },
        { prop: 'channel_name', label: '通道名称', width: 120, resizable: false },
        { prop: 'status', label: '通道状态', width: 90, resizable: false, slot: 'colStatus' },
        { prop: 'currency', label: '支持币种', width: 90, resizable: false },
        { prop: 'payoutLimit', label: '单笔限额', minwWdth: 140, resizable: false, slot: 'colPayoutLimit' },
        { prop: 'payoutFee', label: '提款手续费', width: 100, resizable: false, slot: 'colPayoutFee' },
        { prop: 'weight', label: '权重', width: 70, align: 'center', resizable: false },
        { prop: 'remark', label: '备注', minWidth: 100, resizable: false },
        {
          fixed: 'right',
          prop: 'action',
          label: '操作',
          width: 100,
          align: 'center',
          resizable: false,
          slot: 'colActions',
        },
      ],
      dialogVisible: false,
      dialogMode: 'create',
      editId: null,
      editRow: null,
    }
  },
  methods: {
    request(params) {
      return listPayoutChannels(params)
    },
    buildParams({ query, page, limit }) {
      const params = {
        page,
        page_size: limit,
      }
      if (query.channel_name) params.channel_name = query.channel_name
      if (query.status !== '' && query.status != null) params.status = query.status
      return params
    },
    parseResult(res) {
      const data = (res && res.data) || res
      const rawList = (data && data.list) || (Array.isArray(data) ? data : [])
      const rawTotal = (data && data.total) != null ? data.total : rawList.length
      return {
        list: Array.isArray(rawList)
          ? rawList.map(e => {
              return {
                ...e,
                payout_fee_rate: this.formatFeeRate(e.payout_fee_rate),
              }
            })
          : [],
        total: rawTotal,
      }
    },
    formatFeeRate(feeRate) {
      if (feeRate == null || feeRate === '') return '-'
      const n = Number(feeRate)
      if (!Number.isFinite(n)) return '-'
      // 避免浮点误差（如 0.0035 * 100 -> 0.35000000000000003）
      const raw = (n * 100).toFixed(6)
      const trimmed = raw.replace(/\.?0+$/, '')
      return trimmed
    },
    handleEdit(row) {
      this.dialogMode = 'edit'
      this.editId = row.id
      this.editRow = row
      this.dialogVisible = true
    },
    handleDialogSuccess() {
      this.$refs.tablePageRef?.reload?.()
      this.$emit('update')
    },
  },
}
</script>
